import Head from 'next/head'
import Link from 'next/link';
import User from "../components/user";


import MenuComponent from '../components/menu';
import { GetStaticProps } from "next";
import { ApolloClient, InMemoryCache, gql, useQuery } from "@apollo/client";
import PlaceCartComponent from '../components/placecart'
import { IArticle, SearchInput, facetValueFilterInput} from "../components/contracts/types";
import Header2  from "../components/header-2";
import ProductCard from '../components/ProductCard'
import ImageSlider from '../components/imageslider'

import React, { useState, useEffect } from "react";
import { Queries } from "../services/queries";
import Soffer from '../components/soffer'

import {WEBSERVER, APISERVER, imgpath, numberToCurrency} from "../services/globals"
import { title } from 'process';

//  query SearchProducts($term: String!, $skip: Int, $take: Int) {

const SEARCH_PRODUCTS = gql`
  query SearchProducts($input: SearchInput!) {
  search(input: $input) {
    totalItems
    facetValues {
      count
      facetValue {
        id
        name
        facet {
          id
          name
        }
      }
    }
    items {
      productName
      slug
      description
      sku
      productAsset {
        id
        preview
      }
      productVariantName        
      facetIds
      facetValueIds  

      priceWithTax {
        ... on SinglePrice {
          value
        }
        ... on PriceRange {
          min
          max
        }
      }
      currencyCode
    }
  }
}`;



export default function Home({categories,itemdata}) {

  


  const list = itemdata?.search?.items ?? [];


  let articles:IArticle[] = [];

  for (let [index, item] of list.entries()) {
    let article:IArticle = {
      hid :"",
      id :"",
      hname  :"",
      name  :"",
      slug :"",
      hdescription : "",
      description :"",
      img :"",
      price :"",
      soffer :false,
      vcount : 0
    };
    
    console.log(JSON.stringify(item));

    article.id = item.sku || item.slug || `article-${index}`;
    article.hname = item.productName;
    article.hdescription = item.description;
    article.img = imgpath(item.productAsset.preview);
    article.slug = item.slug;
    article.price =  "ab " + numberToCurrency(item.priceWithTax.min);
    const facetIds = item.facetValueIds ?? item.facetIds ?? [];
    article.soffer = (facetIds || []).some((fid: any) => {
      const n = Number(fid);
      return n === 41 || n === 40;
    });

    articles.push(article);
    console.log(item.productName);
  }

  function detailurl(slug:String) {
    return WEBSERVER + "/items/" + slug;
  }
  const overlay : string = "../soffer.png";
  //  console.log("categories:", categories);
return (
  <div className="">
    <Head>
      <title>Startseite</title>
      <meta name="description" content="Schnäppchen finden lohnt sich für Sport und Zuhause und Computer" />
      <link rel="icon" href="/favicon.ico" />
    </Head>
    <Header2 collections={categories.collections}></Header2>
    <div className="container-fluid">
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {articles.map((elem) => (
          <div className="col" key={elem.id}>
            <ProductCard article={elem} />
          </div>
        ))}
      </div>
    </div>
    <div className="mt-4 text-center"><h3>Ein Blick in das Backend</h3><ImageSlider></ImageSlider></div>
    <div className="d-flex align-items-center justify-content-center">
      <div>
        Build with <a href="https://nextjs.org" target="__new">Next.js</a> and <a href="https://vendure.io" target="__new">Vendure</a>
      </div>
    </div>
  </div>
);
};



export const getStaticProps: GetStaticProps = async () => {
  //  console.log("+++++++ " + context);
    const queries = new Queries(null);
    const categories = await queries.getCategories(); 
    const items = await queries.getItemsSpecialOffer();
  //  console.log("+++++++------ " + JSON.stringify(categories));
    return {
      props: {
        categories: categories,
        itemdata: items,
      },
    };
  };


